export function fuzzyMatchScore(query: string, text: string): number | undefined {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery.length === 0) {
    return 0;
  }

  const normalizedText = text.toLowerCase();
  let queryIndex = 0;
  let score = 0;
  let previousMatchIndex = -1;

  if (normalizedText.startsWith(normalizedQuery)) {
    score += 100;
  }

  for (let textIndex = 0; textIndex < normalizedText.length && queryIndex < normalizedQuery.length; textIndex++) {
    if (normalizedText[textIndex] !== normalizedQuery[queryIndex]) {
      continue;
    }

    score += previousMatchIndex === textIndex - 1 ? 5 : 1;
    if (textIndex === 0 || /[\s_-]/.test(normalizedText[textIndex - 1]!)) {
      score += 3;
    }
    previousMatchIndex = textIndex;
    queryIndex++;
  }

  return queryIndex === normalizedQuery.length ? score : undefined;
}

export function filterByFuzzySearch<T>(items: T[], query: string, getLabel: (item: T) => string): T[] {
  const normalizedQuery = query.trim();
  if (normalizedQuery.length === 0) {
    return items;
  }

  return items
    .flatMap(item => {
      const score = fuzzyMatchScore(normalizedQuery, getLabel(item));
      return score === undefined ? [] : [{ item, score }];
    })
    .sort((left, right) => right.score - left.score || getLabel(left.item).localeCompare(getLabel(right.item), undefined, { sensitivity: "base" }))
    .map(entry => entry.item);
}
